// extracted by mini-css-extract-plugin
export default {"root":"U6ubKCgtx61dN6YsuhMn","wrap":"AT3Cal8JD6SsaHtncrPd"};